module.exports = __webpack_public_path__ + "img/voice-button.fc6be500.png";